import React from 'react';
import PropTypes from 'prop-types';
import {StyledVendorSubscriptions} from './StyledVendorSubscriptions';
import SubscriptionSnippet from '../SubscriptionSnippet';

const VendorSubscriptions = ({
  data = [],
  ...rest
}) => {
  return (
    <StyledVendorSubscriptions
      direction='vertical'
      size='middle'
      {...rest}
    >
      {data.map((item, key) => <SubscriptionSnippet subscription={item} key={key} />)}
    </StyledVendorSubscriptions>
  );
}

VendorSubscriptions.propTypes = {
  data: PropTypes.array
}

export default VendorSubscriptions;
